import React from 'react';
import { useAuth } from '../contexts/AuthContext';

// Wrap module pages that operate on a selected event.
export default function RequireEvent({ children }) {
  const { event } = useAuth();
  if (!event) {
    return (
      <div>
        <div className="page-head"><h1>Select an event</h1></div>
        <div className="card card-pad empty">
          Pick an event from the dropdown at the top to manage its details.
        </div>
      </div>
    );
  }
  return typeof children === 'function' ? children(event) : children;
}
